import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Subject, Observable } from 'rxjs';
import { Disposal } from 'src/app/_models/disposal';
import { HttpClient, HttpParams } from '@angular/common/http';
import { DisposalView } from 'src/app/_models/disposalView';
import { DisposalCorrection } from 'src/app/_models/disposalCorrection';

@Injectable({
   providedIn: 'root',
})
export class DisposalService {
   baseUrl = environment.apiUrl;
   ImportSelected = new Subject<Disposal>();
   disposalSelected = new Subject<Disposal>();
   returnToSupplierSelected = new Subject<Disposal>();

   constructor(private http: HttpClient) {}

   changeEditState(d: Disposal) {
      this.disposalSelected.next(d);
   }

   changeReturnToSupplierState(d: Disposal) {
      this.returnToSupplierSelected.next(d);
   }

   changeImportState(disposal: Disposal) {
      this.ImportSelected.next(disposal);
   }

   getDisposal(id): Observable<Disposal> {
      return this.http.get<Disposal>(this.baseUrl + 'disposal/' + id);
   }
   getDisposalView(id): Observable<DisposalView> {
      return this.http.get<DisposalView>(this.baseUrl + 'disposal/view/' + id);
   }
   getDisposalViewByJournalRef(id): Observable<DisposalView> {
      return this.http.get<DisposalView>(this.baseUrl + 'disposal/view/journalref/' + id);
   }
   getDisposalCorrection(id): Observable<DisposalCorrection> {
      return this.http.get<DisposalCorrection>(this.baseUrl + 'disposal/correction/' + id);
   }
   getHasWorkflow(): Observable<boolean> {
      return this.http.get<boolean>(this.baseUrl + 'disposal/hasWorkflow');
   }
   getDisposalCorrectionByRef(id): Observable<DisposalCorrection> {
      return this.http.get<DisposalCorrection>(this.baseUrl + 'disposal/correction/journalref/' + id);
   }
   createDisposal(disposal: Disposal) {
      return this.http.post(this.baseUrl + 'disposal', disposal);
   }
   updateDisposal(id: number, disposal: Disposal) {
      return this.http.put(this.baseUrl + 'disposal/' + id, disposal);
   }
   cancelDisposal(id: number) {
      return this.http.delete(this.baseUrl + 'disposal/cancel/' + id);
   }
   cancelBulk(ids: number[]) {
      let params = new HttpParams();
      ids.forEach((id) => {
         params = params.append('ids', id.toString());
      });
      return this.http.delete(this.baseUrl + 'disposal/cancel?' + params.toString());
   }
   remove(date: string, type: string) {
      if (type == 'transaction') {
         return this.http.delete(this.baseUrl + 'disposal/removeByTransactionDate/' + date);
      } else {
         return this.http.delete(this.baseUrl + 'disposal/removeByCaptureDate/' + date);
      }
   }
   removeById(id: number) {
      return this.http.delete(this.baseUrl + 'disposal/removebyid/' + id);
   }

   exportForCorrection(): Observable<Blob> {
      // tslint:disable-next-line:max-line-length
      return this.http.get(this.baseUrl + 'disposal/exportForCorrection', {
         responseType: 'blob',
      });
   }

   exportForRemoval(): Observable<Blob> {
      return this.http.get(this.baseUrl + 'disposal/exportForRemoval', {
         responseType: 'blob',
      });
   }

   exportForCancellation(): Observable<Blob> {
      return this.http.get(this.baseUrl + 'disposal/exportForCancellation', {
         responseType: 'blob',
      });
   }

   exportCorrections(): Observable<Blob> {
      // tslint:disable-next-line:max-line-length
      return this.http.get(this.baseUrl + 'disposal/exportcorrections', {
         responseType: 'blob',
      });
   }
}
